module.exports = __webpack_public_path__ + "img/Kilgore.60314af2.jpg";